import { NgModule } from '@angular/core';
import { TranslocoSelectDirective } from './transloco-select.directive';

@NgModule({
  declarations: [TranslocoSelectDirective],
  exports: [TranslocoSelectDirective]
})
export class TranslocoSelectDirectiveModule {}
